import { render } from "./DesignerEditor.vue?vue&type=template&id=11571f3e"
import script from "./DesignerEditor.vue?vue&type=script&lang=js"
export * from "./DesignerEditor.vue?vue&type=script&lang=js"

import "./DesignerEditor.vue?vue&type=style&index=0&id=11571f3e&lang=scss"
script.render = render

export default script